(function(utils) {
	function postaviStatuse(cmbId, statusi, prikaziSveStatuse) {
		for (var i = 0; i < statusi.FCount; ++i) {
			var status = statusi.FItems[i].fields;
			if (!prikaziSveStatuse && status.FId == -1)
				continue;
			$("#" + cmbId).append("<option value=\"" + status.FId + "\">" + status.FNaziv + "</option>");
		}
	}
	
	// Deprecated: koristiti VpStatusi
	function getStatusIzOpcija(opcije) {
		var status = 0;
		var matches = opcije.match(/\d+/);
		if (matches != null && matches.length > 0)
			status = parseInt(matches[0], 10);
		return status;
	}
	
	function provjeriDZaglavZakljucan(url, onNezakljucan) {
		$.ajax({
			url: url,
			dataType: "JSON",
			success: function(data, textStatus, jqXHR) {
				if (data == true) {
					prikaziZakljucanDialog();
				}
				else {
					onNezakljucan();	
				}
			}	
		});	
	}
	
	function provjeriRacunZakljucan(url, onNezakljucan, onZakljucan) {
		$.dsJSON({
			url: url,
			done: function (data) { 
				if (data === false) {
					if (onNezakljucan) onNezakljucan();
				}
				else if (data === true) {
					if (onZakljucan) onZakljucan();
				}
			}
		});
	}
	
	function provjeriKZaglavZakljucan(url, onNezakljucan) {
		$.ajax({
			url: url,
			dataType: "JSON",
			success: function(data, textStatus, jqXHR) {
				if (data == true) {
					prikaziZakljucanDialog();
				} else {
					onNezakljucan();
				}
			}
		});
	}
	
	function prikaziZakljucanDialog() {
		var dlgZakljucan = $("<div id=\"dlg-zakljucan\">Dokument je zaključan i ne može se mijenjati.</div>");
		dlgZakljucan.dialog({
			modal: true,
			title: "Upozorenje",
			buttons: {
				"U redu": function() { $(this).dialog("close"); }
			}
		});
	}
	
	utils.nazivTipaArtikla = function(tip){
		if (tip == 'N'){
			return 'Roba';
		}else if (tip == 'G'){
			return 'Gotovi proizvod';
		}else if (tip == 'U'){
			return 'Usluga';	
		}else if (tip == 'P'){
			return 'Paket';
		}else if (tip == 'O'){
			return 'Opis';	
		}else{
			return '';	
		}
	};
	
	//Sheme artikala su definirane u VpPram L2258 
    utils.artiklTipRoba = function(tip){
        return (tip == 'G') || (tip == 'N');
    };	
	
	utils.artiklTipUsluga = function(tip){
		return (tip == 'U');
	};
	
	utils.artiklTipOpis = function(tip){
		return (tip == 'O');
	};
	
	utils.artiklTipPaket = function(tip){
		return (tip == 'P');
	};
	
	utils.artiklTipRobaUsluga = function(tip){
	    return utils.artiklTipRoba(tip) || utils.artiklTipUsluga(tip);
	};
	
	utils.formatArtikl = function(artikl, bArtiklJeBroj, iArtiklDuljina){
		if ((bArtiklJeBroj) && (artikl != '')){
			return artikl.padStart(iArtiklDuljina, " ");  
		}else{
			return artikl;
		}	
	};
	
	utils.artiklTipOdreden = function(tip){
    	if (tip) return true;
    	return false;	
    };
    
	utils.dohvatiControllerPremaTipu = function(tip) {
		var controller = "dzaglav";		
		if ((tip == "racun") || (tip == "povratnica") || (tip == "ponuda") || (tip == "ugovor")) {
			controller = 'racun';	
		}			
		return controller;
	};   
	
	utils.ponistiIznoseDStavke = function(uniqueId){
        $('#pDnoNIznos-' + uniqueId).text('...');
        $('#pDnoPIznos-' + uniqueId).text('...');
        $('#pDnoRabatICassa-' + uniqueId).text('...');
        $('#pDnoBezPoreza-' + uniqueId).text('...'); 
        $('#pDnoIznosPoreza-' + uniqueId).text('...');
        $('#pDnoIznosSPorezom-' + uniqueId).text('...'); 
	};
	
	utils.osjveziIznoseDStavke = function(godina, skladiste, vpDokum, broj, vrsta, racun, pozivIzRacuna, uniqueId){
		utils.ponistiIznoseDStavke(uniqueId);
        konto.vp.api.DohvatiIznoseDStavke(godina, skladiste, vpDokum, broj, vrsta, racun, pozivIzRacuna).then(function(iznos){
            $('#pDnoNIznos-' + uniqueId).text(iznos.Nabavni).addClass('BCSelected'); 
            $('#pDnoPIznos-' + uniqueId).text(iznos.Prodajni).addClass('BCSelected');
            $('#pDnoRabatICassa-' + uniqueId).text(iznos.RabatICassa).addClass('BCSelected');
            $('#pDnoBezPoreza-' + uniqueId).text(iznos.BezPoreza).addClass('BCSelected'); 
            $('#pDnoIznosPoreza-' + uniqueId).text(iznos.Poreza).addClass('BCSelected');
            $('#pDnoIznosSPorezom-' + uniqueId).text(iznos.SPorezom).addClass('BCSelected');
        });
	};
	
	utils.ponistiPostoMarzeDStavke = function(uniqueId){
		$('#pDnoIznosPostoMarze-' + uniqueId).text('...');	
	};
	
	utils.osjveziPostoMarzeDStavke = function(godina, vrsta, racun, uniqueId){
		utils.ponistiPostoMarzeDStavke(uniqueId);
        konto.vp.api.DohvatiPostoMarzeDStavke(godina, vrsta, racun).then(function(iznosPosto){
            $('#pDnoIznosPostoMarze-' + uniqueId).text(iznosPosto.Iznos + ', ' + iznosPosto.Posto).addClass('BCSelected'); 
        });	
	};
	
	utils.ponistiMasuAOpisDStavke = function(uniqueId){
		$('#pDnoUkupnaMasa-' + uniqueId).text('...');	
	};
	
	utils.osvijeziMasuAOpisDStavke = function(godina, vrsta, racun, uniqueId){
		utils.ponistiMasuAOpisDStavke(uniqueId);
        konto.vp.api.DohvatiMasuAOpisDStavke(godina, vrsta, racun).then(function(masa){
            $('#pDnoUkupnaMasa-' + uniqueId).text(masa).addClass('BCSelected'); 
        });	
	};
		
	utils.dStavkePaste = function(sifarnik, pozivIzRacuna){
		var data = sifarnik.kontoGrid.getSelectedData();
		var vrsta = '';
		var racun = 0;
		if (pozivIzRacuna){
			vrsta = data.VRSTA;
			racun = data.RACUN;	
		} 
		KUtils.busy(true);
		konto.vp.api.DStavkePaste(data.GODINA, data.SKLADISTE, data.VPDOKUM, data.BROJ, pozivIzRacuna, vrsta, racun)
			.done(function(rez){
				sifarnik.kontoGrid.refresh(true);			
				sifarnik.dStavke.refresh(true);
				KUtils.busy(false);
			});	
	};
	
	utils.dStavkeCopy = function(sifarnik){	
		var data = sifarnik.dStavke.getSelectedData();	
   		var dataCB = sifarnik.dStavke.getCheckedData();
   		if (dataCB.length == 0){  			
   			dataCB.push(data.STAVKA);   			
   		}else{
   			$.each(dataCB, function (key, value) {
				dataCB[key] = value.STAVKA;
			});
   		}
   		
   		KUtils.busy(true);
		konto.vp.api.DStavkeCopy(data.GODINA, data.SKLADISTE, data.VPDOKUM, data.BROJ, dataCB)
			.done(function(rez){
				KUtils.busy(false);
			});			
	};
	
	utils.dStavkePitajDef = $.Deferred();
	
	utils.dStavkePitajBrisanje = function(war, i, obj){
		if (war.length > i){ 
            konto.dialogs.upit({ 
                content: war[i].WarningMsg,
                potvrdi: function(){  utils.dStavkePitajBrisanje(war, ++i, obj) },
                odustani: function(){ 
					obj.izvrsiBrisanje = false; 
					utils.dStavkePitajDef.notify(obj); 
				} 
            }); 
        }else if (war.length == i){
            obj.izvrsiBrisanje = true;
            utils.dStavkePitajDef.notify(obj);
        }
	}
	
	utils.dStavkePitajDef.progress(function(objZaBrisanje){
	    if (objZaBrisanje.izvrsiBrisanje){
            KUtils.busy(true);
            utils.stavkaObrisiList(objZaBrisanje)
                .done(function(){
					objZaBrisanje.sifDStavke.refreshAfterDelete(); // -> zbog pozicioniranje na stavku nakon brisanja
                    objZaBrisanje.sifKontoGrid.refresh(); // -> zbog iznosa se refresha zaglavlje koje indirektno refresha stavke 
            		KUtils.busy(false);  
                });
	    }
	});
	
	utils.stavkaZakljucanaPoDZaglavIliRacun = function(obj, pozivIzRacuna){
        if (pozivIzRacuna){
			return konto.vp.api.GetRacunZakljucan(obj.GODINA, obj.VRSTA, obj.RACUN);
		}else{
			return konto.vp.api.GetDZaglavZakljucan(obj.GODINA, obj.SKLADISTE, obj.VPDOKUM, obj.BROJ, 1, 0);	
		}
	};
	
	utils.stavkaBrisanjeInteract = function(obj, dataCB, pozivIzRacuna){
        if (pozivIzRacuna){
			return konto.vp.api.GetDStavkeRacunBrisanjeInteract(obj.GODINA, obj.VRSTA, obj.RACUN, dataCB);
		}else{
			return konto.vp.api.GetDStavkeBrisanjeInteract(obj.GODINA, obj.SKLADISTE, obj.VPDOKUM, obj.BROJ, dataCB);	
		}	
	}
	
	utils.stavkaObrisiList = function(objZaBrisanje){
		var obj = objZaBrisanje.obj;
		var dataCB = objZaBrisanje.dataCB;
		var bNapravitiZapisnikPC = objZaBrisanje.bNapravitiZapisnikPC;
        if (objZaBrisanje.pozivIzRacuna){
			return konto.vp.api.DStavkeRacunObrisiList(obj.GODINA, obj.VRSTA, obj.RACUN, dataCB, bNapravitiZapisnikPC);
		}else{
			return konto.vp.api.DStavkeObrisiList(obj.GODINA, obj.SKLADISTE, obj.VPDOKUM, obj.BROJ, dataCB, false, bNapravitiZapisnikPC);	
		}	
	}
	
	utils.dStavkeBrisanje = function(sifarnik, pozivIzRacuna){	
		var obj = sifarnik.kontoGrid.getSelectedData();
        var data = sifarnik.dStavke.getSelectedData();

		utils.stavkaZakljucanaPoDZaglavIliRacun(obj, pozivIzRacuna).then(function(rez){
			debugger;
           if (rez.FWarningMsg != ""){
                konto.dialogs.upozori({width:"35%", content: rez.FWarningMsg });  
           }else{
           		var dataCB = sifarnik.dStavke.getCheckedData();
           		if (dataCB.length == 0){
           			var data = sifarnik.dStavke.getSelectedData();
           			dataCB.push(data.STAVKA);
           		}else{
           			$.each(dataCB, function (key, value) {
        				dataCB[key] = value.STAVKA;
        			});
           		}
           		utils.stavkaBrisanjeInteract(obj, dataCB, pozivIzRacuna).then(function(valRes){
					   debugger;
					var bNapravitiZapisnikPC = false;
           			if (valRes.error){
						//Obrada je na povratu iz DS-a, ne treba i ovdje obrađivati   								   
					}else if (valRes.FWarningMsg){
						bNapravitiZapisnikPC = (valRes.FSuccessType == "FbNapravitiZapisnikPC");
						var objZaBrisanje = {};
						objZaBrisanje.obj = obj;
						objZaBrisanje.dataCB = dataCB;
						objZaBrisanje.pozivIzRacuna = pozivIzRacuna;
						objZaBrisanje.bNapravitiZapisnikPC = bNapravitiZapisnikPC;
						objZaBrisanje.sifDStavke = sifarnik.dStavke;
						objZaBrisanje.sifKontoGrid = sifarnik.kontoGrid  
						
						//obrada warninga / pitanja	
						utils.dStavkePitajBrisanje(valRes.Warnings, 0, objZaBrisanje);							
					}
            	});
			}
		});
	};	
	
	utils.kStavkePaste = function(sifarnik){
		var data = sifarnik.kontoGrid.getSelectedData();
		KUtils.busy(true);
		konto.vp.api.KStavkePaste(data.GODINA, data.VRSTA, data.KALKULACIJA)
			.done(function(rez){
				sifarnik.kontoGrid.refresh(true);			
				sifarnik.kStavke.refresh(true);
				KUtils.busy(false);
			});	
	};
	
	utils.kStavkeCopy = function(sifarnik){	
		var data = sifarnik.kStavke.getSelectedData();	
   		var dataCB = sifarnik.kStavke.getCheckedData();
   		if (dataCB.length == 0){  			
   			dataCB.push(data.STAVKA);   			
   		}else{
   			$.each(dataCB, function (key, value) {
				dataCB[key] = value.STAVKA;
			});
   		}
   		
   		KUtils.busy(true);
		konto.vp.api.KStavkeCopy(data.GODINA, data.VRSTA, data.KALKULACIJA, dataCB)
			.done(function(rez){
				KUtils.busy(false);
			});			
	};
		
	utils.kStavkeBrisanjeClick = function(sifarnik){
		var objKZaglav = sifarnik.kontoGrid.getSelectedData();
        var data = sifarnik.kStavke.getSelectedData();
        konto.vp.api.GetKZaglavZakljucan(objKZaglav.GODINA, objKZaglav.VRSTA, objKZaglav.KALKULACIJA).then(function(rez){
           if (rez.FWarningMsg != ""){
                konto.dialogs.upozori({width:"35%", content: rez.FWarningMsg });  
           }else{
           		var dataCB = sifarnik.kStavke.getCheckedData();
           		if (dataCB.length == 0){
           			var data = sifarnik.kStavke.getSelectedData();
           			dataCB.push(data.STAVKA);
           		}else{
           			$.each(dataCB, function (key, value) {
        				dataCB[key] = value.STAVKA;
        			});
           		}
           		poruka = 'Obrisati stavke: ' + dataCB.join() + '?';
                konto.dialogs.modal({
                    title: "Upozorenje",
                    content: poruka,
                    width: '600px',
                    buttons: {
                        "Da": {
                            click: function () {
                                var that = this;
                                konto.vp.api.KStavkeObrisiList(objKZaglav.GODINA, objKZaglav.VRSTA, objKZaglav.KALKULACIJA, dataCB)
                                    .done(function(){
                                        sifarnik.kStavke.refreshAfterDelete();    
                                    });
                                that.close();
                            },
                            isPrimary: true
                        },
                        "Ne": {
                            click: function () { this.close(); },
                        }
                    }
                });
            
			}	    
        }); 
	};	
	
	utils.ponistiIznoseKStavke = function(uniqueId){
		/*
        $('#pDnoNIznos-' + uniqueId).text('...');
        $('#pDnoPIznos-' + uniqueId).text('...');
        $('#pDnoRabatICassa-' + uniqueId).text('...');
        $('#pDnoBezPoreza-' + uniqueId).text('...'); 
        $('#pDnoIznosPoreza-' + uniqueId).text('...');
        $('#pDnoIznosSPorezom-' + uniqueId).text('...'); 
        */
	};
	
	utils.osjveziIznoseKStavke = function(godina, vrsta, kalkulacija, uniqueId){
		utils.ponistiIznoseKStavke(uniqueId);
		/*
        konto.vp.api.DohvatiIznoseDStavke(godina, skladiste, vpDokum, broj, vrsta, racun, pozivIzRacuna).then(function(iznos){
            $('#pDnoNIznos-' + uniqueId).text(iznos.Nabavni).addClass('BCSelected'); 
            $('#pDnoPIznos-' + uniqueId).text(iznos.Prodajni).addClass('BCSelected');
            $('#pDnoRabatICassa-' + uniqueId).text(iznos.RabatICassa).addClass('BCSelected');
            $('#pDnoBezPoreza-' + uniqueId).text(iznos.BezPoreza).addClass('BCSelected'); 
            $('#pDnoIznosPoreza-' + uniqueId).text(iznos.Poreza).addClass('BCSelected');
            $('#pDnoIznosSPorezom-' + uniqueId).text(iznos.SPorezom).addClass('BCSelected');
        });
        */
	};
	
	utils.TraziASpojenObradiRes = function(res){
        if (res.FSuccessMsg != ''){ 
            konto.dialogs.modal({
                title: "Obavijest",
                content: '<pre class="nonClickable" readOnly style="font-family:Helvetica Neue,Helvetica,Arial,sans-serif;background-color:white;border:none;">' + 
                            res.FSuccessMsg +
                       '</pre>',
                width: '45%',
                buttons: {
                    "Zatvori": {
                        click: function () { 
                            this.close(); 
                        }
                    }
                }
            });
        }else if (res.FErrorMsg != ''){
            konto.dialogs.upozori({content: res.FErrorMsg});     
        }    
	};	
	
	utils.osvjeziPrivitkeIzDA = function (godina, vrsta, racun) {          
		konto.vp.utils.GetERacunPriviciIzDA(godina, vrsta, racun);		
		$("body").data("pozivIzIspisaRacuna", false);			
	};
	
	utils.GetERacunPriviciIzDA = function (godina, vrsta, racun) {
    	konto.vp.api.GetERacunPriviciIzDA(godina, vrsta, racun)
    		.done(function(rez){
            	if(rez.DatotekeDokumenta.length == 0) {           		
            		var html = '<div class="row">&nbsp;</div>'; 
            		$('.edERacunDigArhivaDatoteke').html(html);	
            	} 
            	else {           		
	    			var elc = $('.edERacunDigArhivaDatoteke').find('input:checkbox').length;
	    			if((elc != rez.DatotekeDokumenta.length) || (getRacunId() != getRacunIdBefore())){
		            	var eRacunDatotekeDokumenta = rez.DatotekeDokumenta;  
						var eRacunJePrilogUzERacun = rez.JePrilogUzERacun; 
	            		var html = '';
	            								
		            	for (i=0; i<eRacunDatotekeDokumenta.length; i++){
		                	var privitak = eRacunDatotekeDokumenta[i];
		                	var caption = privitak.FFileName + ' (' + privitak.FDatoteka + ')';    
							html = html + '<div class="row">';    	
		                	html = html + '<div class="col-md-1"><input type="checkbox" class="cursorPointer kce_valigntop no-storage ne-ponisti" ';
							if(eRacunJePrilogUzERacun[i] == 'True')
		 					{
			                	html = html + 'checked';
			                };
			                html = html + ' id="cbPrilogUzERacun_' + i + '" ';
		                	html = html + '><input type="hidden" id="cbPrilogUzERacunDatoteka_' + i + '" value="' + privitak.FDatoteka + '" ></div>';
		                	html = html + '<div class="col-md-11">' + caption + '</div>'; 
		                	html = html + '</div>';                  	             	
		            	}  
		            	$('.edERacunDigArhivaDatoteke').html(html);	   
	    			}            		
            	}    			
				setRacunIdBefore(); 
    		});	
	}; 
	
	utils.GetFiskalizacijaCaption = function (lnFiskalizacija){
	    if((lnFiskalizacija === undefined) || (lnFiskalizacija == null)){
	    	return 'Ne ulazi u fiskalizaciju';
	    }	        
	    else if(lnFiskalizacija == -1){
	    	return 'Ne šalje se na fiskalizaciju';	
	    } 	       
	    else if(lnFiskalizacija == 0){
	    	return 'Nije spreman za fiskalizaciju';	
	    } 	       
	    else if(lnFiskalizacija == 1){
	    	return 'Čeka slanje na fiskalizaciju';
	    } 	        
	    else if(lnFiskalizacija == 2){
	    	return 'Nije uspješno fiskaliziran, čeka slanje na fiskalizaciju';
	    } 	      
	    else if(lnFiskalizacija == 3){
	    	return 'Fiskaliziran';
	    } 	        		
	};
	
	utils.FiskalizacijaPojedinacnogRacuna = function (sifarnik, godina, skladiste, vrsta, racun, fiskalizacija, upitati){
			if(upitati){
	    		KUtils.busy(true);				
			}
	    	konto.vp.api.RacunFiskalizacijaOznacenogRacuna(godina, skladiste, vrsta, racun, fiskalizacija)
	    	.done(function(rez){
	    		if(rez.VRSTA == 'GRESKA'){
	            	KUtils.busy(false);
	    			konto.dialogs.obavijest({width:"35%", content: rez.PORUKA});	
	    		}
	    		else if(rez.VRSTA == 'UPIT'){
	    			if(upitati){
		            	KUtils.busy(false); 
		                konto.dialogs.upit({
		                    width: '500px',
		                    title: 'Odgovorite', 
		                    content: rez.PORUKA,
		                    close: function () {
		                    	sifarnik.kontoGrid.refresh(true);
		                    },
		                    buttons: {
		                       "Da": {
		                            click: function () {
				                    	KUtils.busy(true);
		                            	that = this;
		                        		konto.vp.api.PripremiRacunZaFiskalizaciju(godina, skladiste, vrsta, racun, fiskalizacija)
		                        			.done(function(rez){
						                    	KUtils.busy(false);
		                        				that.close();
		                        				if((rez != "") && (rez !== undefined)){
		                        					konto.dialogs.obavijest({title: "Greška", width:"35%", content: rez});	
		                        				}	                                    					
		                        			});
		                            },
		                            isPrimary: true
		                        },
		                        "Ne": {
		                            click: function () {
		                                this.close();
		                            },
		                        }, 
		                    }
		                });  
	                }
			    	else {
			    		KUtils.busy(true);
			    		konto.vp.api.PripremiRacunZaFiskalizaciju(godina, skladiste, vrsta, racun, fiskalizacija)
			    			.done(function(rez){
								KUtils.busy(false);			    				
			    				if((rez != "") && (rez !== undefined)){
			    					konto.dialogs.obavijest({title: "Greška", width:"35%", content: rez});	
			    				}	
			    				sifarnik.kontoGrid.refresh(true); 			    				                                   				
			    			});            		
			    	}  	                        		                  			                      			
	    		}
	    	}); 			   	    	   		
	};
	
	utils.UbaciRjesenjeUMemo = function( $button, $memo){
	    var linkR = kontorouter.getModulPath("rjesenje/pregled");
        $button.click(function(){ 
            konto.dialogs.sifarnik({
                template: linkR,
                odabir: function(data){
                    if (data){
                        konto.vp.api.GetRjRedakTekst(data.RJESENJE).then(function(res){
                            vecUpisano = $memo.val();
                            vecUpisano += res;
                            $memo.val(vecUpisano); 
                        });
                    }
                }
            }); 
        });
	};
	
	utils.GetVrsteOvlastenjaData = function(){
        return [
            {vrsta:0, naziv:"Sva ovlaštenja"},
            {vrsta:1, naziv:"Pravo na organizacijsku jedinicu"},
            {vrsta:2, naziv:"Pravo na status"},
            {vrsta:3, naziv:"Korištenje art. po grupi art.4"},
            {vrsta:4, naziv:"Pravila promjene statusa"},
            {vrsta:5, naziv:"Odgovorna osoba OJ"},
            {vrsta:6, naziv:"Vidi samo svoje dokumente"},
        ];   
	};

	utils.cStavkePaste = function(sifarnik){
		var data = sifarnik.kontoGrid.getSelectedData();
		KUtils.busy(true);
		konto.vp.api.CStavkePaste(data.GODINA, data.TIP, data.CJENIK)
			.done(function(rez){
				sifarnik.kontoGrid.refresh(true);			
				sifarnik.cStavke.refresh(true);
				KUtils.busy(false);
			});	
	};
	
	utils.cStavkeCopy = function(sifarnik){	
		var data = sifarnik.cStavke.getSelectedData();	
   		var dataCB = sifarnik.cStavke.getCheckedData();
   		if (dataCB.length == 0){  			
   			dataCB.push(data.STAVKA);   			
   		}else{
   			$.each(dataCB, function (key, value) {
				dataCB[key] = value.STAVKA;
			});
   		}
   		
   		KUtils.busy(true);
		konto.vp.api.CStavkeCopy(data.GODINA, data.TIP, data.CJENIK, dataCB)
			.done(function(rez){
				KUtils.busy(false);
			});			
	};	
		    
} (konto.vp.utils = {}));
